import CountFieldCharacters from '../../utils/count_field_characters';

$(document).on('turbolinks:load', function () {
    new CountFieldCharacters().handler_events(
        '.js-suggested-description-occurrence',
        '.js-suggested-description-count-input',
        '.js-suggested-description-count-indicator'
    );

});